import * as tslib_1 from "tslib";
import { Injector } from '@angular/core';
import { WpUtils } from "../../web-player-utils";
import { ContextMenuComponent } from "../../context-menu/context-menu.component";
var AlbumContextMenuComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AlbumContextMenuComponent, _super);
    function AlbumContextMenuComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        return _this;
    }
    /**
     * Copy fully qualified album url to clipboard.
     */
    AlbumContextMenuComponent.prototype.copyLinkToClipboard = function () {
        _super.prototype.copyLinkToClipboard.call(this, 'album');
    };
    /**
     * Get tracks that should be used by context menu.
     */
    AlbumContextMenuComponent.prototype.getTracks = function () {
        return WpUtils.assignAlbumToTracks(this.data.item.tracks, this.data.item);
    };
    return AlbumContextMenuComponent;
}(ContextMenuComponent));
export { AlbumContextMenuComponent };
